import { createSlice } from "@reduxjs/toolkit";
import { LAYOUTS } from "../../constants/general";

const initialState = {
  id: null,
  layout: LAYOUTS.LANDSCAPE,
  name: "",
  category: "",
  bgMusic: null,
  type: "user-template",
  scaleFactor: 1,
  loading: true, // state for setproject function set elements on canvas,
  isFaceless: false,
  isDoc: false,
  isLinkVideo: false,
  isOnlyAvatar: false,
  isNonVoice: false,
  isOnlyAIVoice: false,
  isAIdubbingVoice: false,
  // avatar: {
  //   url: "https://dev.vidboard.ai/media/new_avatars/color_avatars/26.png",
  //   avatarCode: "26",
  //   gender: "male",
  // },
  pro_avatar: undefined,
  scriptVolume: 1,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setProjectId: (state, action) => {
      state.id = action.payload;
    },
    setProjectLayout: (state, action) => {
      state.layout = action.payload;
    },
    setProjectName: (state, action) => {
      state.name = action.payload;
    },
    setProjectCategory: (state, action) => {
      state.category = action.payload;
    },
    setProjectMusic: (state, action) => {
      state.bgMusic = action.payload;
    },
    setProjectType: (state, action) => {
      state.type = action.payload;
    },
    setScaleFactor: (state, action) => {
      state.scaleFactor = action.payload || 1;
    },
    setProjectLoading: (state, action) => {
      state.loading = action.payload ?? !state.loading;
    },
    setIsFacelessVideo: (state, action) => {
      state.isFaceless = !!action.payload;
    },
    setIsNonVoice: (state, action) => {
      state.isNonVoice = !!action.payload;
    },
    setIsDoc: (state, action) => {
      state.isDoc = !!action.payload;
    },
    setIsLink: (state, action) => {
      state.isLinkVideo = !!action.payload;
    },
    setIsOnlyAvatar: (state, action) => {
      state.isOnlyAvatar = !!action.payload;
    },
    setIsOnlyAvatarUrl: (state, action) => {
      state.avatar = action.payload || 1;
    },
    setIsProAvatar: (state, action) => {
      state.pro_avatar = action.payload || 1;
    },
    setIsOnlyAIVoice: (state, action) => {
      state.isOnlyAIVoice = action.payload;
    },
    setScriptVolume: (state, action) => {
      state.scriptVolume = action.payload || 1;
    },
    setIsAIdubbingVoice: (state, action) => {
      state.isAIdubbingVoice = action.payload;
    },
  },
});

export const {
  setProjectId,
  setProjectLayout,
  setProjectName,
  setProjectCategory,
  setProjectMusic,
  setProjectType,
  setScaleFactor,
  setAvatarGender,
  setProjectLoading,
  setIsFacelessVideo,
  setIsDoc,
  setIsLink,
  setIsOnlyAvatar,
  setIsOnlyAvatarUrl,
  setIsProAvatar,
  setIsSubtitle,
  setScriptVolume,
  setIsNonVoice,
  setIsOnlyAIVoice,
  setIsAIdubbingVoice,
} = projectSlice.actions;
export default projectSlice.reducer;
